type Point = { x: number; y: number };
export type PointerIntent = { start: Point; moved: boolean };

/** Screen pixels: stable at any canvas zoom, tolerant of small mouse/touch jitter. */
export function updatePointerIntent<T extends PointerIntent>(intent: T, point: Point): T {
  if (intent.moved || Math.hypot(point.x - intent.start.x, point.y - intent.start.y) < 6) return intent;
  return { ...intent, moved: true };
}

export function isPointerActivation(intent: PointerIntent, point: Point, eventType: string): boolean {
  return eventType === "pointerup" && !updatePointerIntent(intent, point).moved;
}
